module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/setrole/setrole.component.css
// module id = ./src/app/setrole/setrole.component.css
// module chunks = main